import axios from 'axios';

// Configuración de las URLs de la API
const API_URLS = {
    production: 'https://centro-infantil-mijardin.onrender.com/api/actividades/',
    development: 'http://localhost:5000/api/actividades/'
};

// Determinar la URL base según el entorno
const API_URL = process.env.NODE_ENV === 'production' ? API_URLS.production : API_URLS.development;

// Configuración global de axios
axios.defaults.withCredentials = true;

export const crearActividad = async (datosActividad) => {
    try {
        const response = await axios.post(`${API_URL}/crear-actividad`, datosActividad, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            }
        });
        return response.data;
    } catch (error) {
        throw new Error('Error al crear la actividad: ' + error.response?.data?.message || error.message);
    }
};

export const obtenerActividadesProfesor = async (idProfesor) => {
    try {
        const response = await axios.get(`${API_URL}/obtener-actividades-profesor/${idProfesor}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            }
        });
        return response.data;
    } catch (error) {
        throw new Error('Error al obtener las actividades: ' + error.response?.data?.message || error.message);
    }
};

export const actualizarActividad = async (id, datosActividad) => {
    try {
        // Solo enviamos los campos que tienen valor
        const datosActualizados = {};
        Object.keys(datosActividad).forEach(key => {
            if (datosActividad[key] !== undefined && datosActividad[key] !== null) {
                datosActualizados[key] = datosActividad[key];
            }
        });

        const response = await axios.put(`${API_URL}/actualizar-actividad/${id}`, datosActualizados, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            }
        });
        return response.data;
    } catch (error) {
        throw new Error('Error al actualizar la actividad: ' + error.response?.data?.message || error.message);
    }
};

export const eliminarActividad = async (id) => {
    try {
        const response = await axios.delete(`${API_URL}/eliminar-actividad/${id}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            }
        });
        return response.data;
    } catch (error) {
        throw new Error('Error al eliminar la actividad: ' + error.response?.data?.message || error.message);
    }
};

export const obtenerActividadesNino = async (id_child) => {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No se encontró un token de autenticación');
        }

        const response = await axios.get(`${API_URL}/actividades-nino/${id_child}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        return response.data;
    } catch (error) {
        throw error;
    }
};

// Servicios para actividades extracurriculares
export const crearActividadExtracurricular = async (datosActividad) => {
    try {
        const formData = new FormData();
        
        // Agregar los campos de texto al FormData
        Object.keys(datosActividad).forEach(key => {
            if (key !== 'archivo') {
                formData.append(key, datosActividad[key]);
            }
        });

        // Agregar el archivo si existe
        if (datosActividad.archivo) {
            formData.append('archivo', datosActividad.archivo);
        }

        const response = await axios.post(`${API_URL}/actividad-extracurricular`, formData, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    } catch (error) {
        throw new Error('Error al crear la actividad extracurricular: ' + error.response?.data?.message || error.message);
    }
};

export const actualizarActividadExtracurricular = async (id, datosActividad) => {
    try {
        const formData = new FormData();
        
        // Agregar solo los campos que están definidos al FormData
        Object.keys(datosActividad).forEach(key => {
            if (datosActividad[key] !== undefined && datosActividad[key] !== null) {
                if (key === 'borrarArchivo' || key === 'borrarArchivoPadre') {
                    formData.append(key, datosActividad[key] === true);
                } else if (key === 'id_child' && Array.isArray(datosActividad[key])) {
                    // Si id_child es un array, tomar el primer elemento
                    formData.append(key, datosActividad[key][0]);
                } else if (key !== 'archivo' && key !== 'archivo_padre') {
                    formData.append(key, datosActividad[key]);
                }
            }
        });

        // Agregar el archivo del profesor si existe y no se está intentando borrar
        if (datosActividad.archivo && !datosActividad.borrarArchivo) {
            formData.append('archivo', datosActividad.archivo);
        }

        // Agregar el archivo del padre si existe y no se está intentando borrar
        if (datosActividad.archivo_padre && !datosActividad.borrarArchivoPadre) {
            formData.append('archivo_padre', datosActividad.archivo_padre);
        }

        const response = await axios.put(`${API_URL}/actualizar-actividad-extracurricular/${id}`, formData, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    } catch (error) {
        throw new Error('Error al actualizar la actividad extracurricular: ' + error.response?.data?.message || error.message);
    }
};

export const eliminarActividadExtracurricular = async (id) => {
    try {
        const response = await axios.delete(`${API_URL}/eliminar-actividad-extracurricular/${id}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            }
        });
        return response.data;
    } catch (error) {
        throw new Error( error.response?.data?.message || error.message);
    }
};

export const obtenerActividadesExtracurricularesPorProfesor = async (id_profesor) => {
    try {
        const response = await axios.get(`${API_URL}/actividades-extracurriculares-profesor/${id_profesor}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            }
        });

        // Si no hay actividades en la respuesta, devolver un array vacío
        if (!response.data || !response.data.actividades) {
            return { actividades: [] };
        }

        return response.data;
    } catch (error) {
        throw new Error('Error al obtener las actividades extracurriculares: ' + (error.response?.data?.message || error.message));
    }
};

export const obtenerTodasActividadesExtracurriculares = async () => {
    try {
        const response = await axios.get(`${API_URL}/actividades-extracurriculares`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            }
        });

        // Si no hay actividades en la respuesta, devolver un array vacío
        if (!response.data || !response.data.actividades) {
            return { actividades: [] };
        }

        return response.data;
    } catch (error) {
        throw new Error('Error al obtener las actividades extracurriculares: ' + error.response?.data?.message || error.message);
    }
};

export const obtenerActividadesExtracurricularesPorNino = async (id_child) => {
    try {
        const response = await axios.get(`${API_URL}/actividades-extracurriculares-nino/${id_child}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            }
        });

        // Si no hay actividades en la respuesta, devolver un array vacío
        if (!response.data || !response.data.actividades) {
            return { actividades: [] };
        }

        return response.data;
    } catch (error) {
        throw new Error('Error al obtener las actividades extracurriculares del niño: ' + (error.response?.data?.message || error.message));
    }
};
